import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../services/report.service';
import {
  NotificationService,
  BackendService,
  ListService,
  FieldStructure,
  TableSettings,
} from 'beyond-util';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { UtilServiceClient } from '../../../services/util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';
import { ReportNameEnum } from '../../../enums/report-name.enum';
import { EndpointTypeEnum } from '../../../enums/endpoint-type.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { IzvestajSettings } from '../prihodi-po-emisijama/izvestaj-settings.service';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { DEFAULT_DATE_FORMAT } from '../../../constants/date-format';
import * as moment from 'moment';
import { RequestTypeEnum } from '../../../enums/request-type.enum';
import { EnumService } from '../../../services/enum.service';
import { RGatewayRequest } from '../../../models/RGatewayRequest';
import { MimeFileType } from '../../../enums/mime-file-type.enum';
import { Subject } from 'rxjs/Subject';
import { ActionType } from '../../../enums/action-type.enum';
import { IGlinkTotals } from './glink-totals';

@Component({
  selector: 'app-glink-maska-16',
  templateUrl: './glink-maska-16.component.html',
  styleUrls: ['./glink-maska-16.component.scss'],
})
export class GlinkMaska16Component extends IzvestajBaseComponent
  implements OnInit {
  constructor(
    protected _backendService: BackendService,
    protected reportService: ReportService,
    protected notificationService: NotificationService,
    protected _rtsBackendService: RtsBackendService,
    protected _listService: ListService,
    protected utilService: UtilServiceClient,
    private _spinner: NgxSpinnerService,
    protected izvestajSettings: IzvestajSettings,
    private enumService: EnumService
  ) {
    super(_backendService);
    this.orderList = [];
    this.name = 'Pregled rezervisanih termina';
  }

  canGenerate = false;
  public validateSubject: Subject<any> = new Subject<any>();
  public validateSubject$ = this.validateSubject.asObservable();

  report: any = {};
  public totals: IGlinkTotals = new IGlinkTotals();

  ngOnInit() {
    this.enumService.fetchTipoviUgovora();
    this.enumService.fetchStatusUgovora();
    this.fetchProgrami();
    this._listService.enumItemsSet.subscribe(item => {
      if (item === 'ProgramIdEnum') {
        super.ngOnInit();
      }
    });

    this.refresh();
  }

  refresh() {
    this.report = {
      DatumOd: new Date(),
      DatumDo: new Date(),
      ProgramIds: [],
      Ugovor: null,
      Podugovor: null,
      Status: [],
    };

    if (this.fieldStructure) {
      this.fieldStructure.getFieldByName('Podugovor').editable = false;
      this.fieldStructure.getFieldByName('Podugovor').additable = false;
    }

    this.totals = new IGlinkTotals();
  }

  goToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  goToTop(topButton: HTMLElement) {
    window.scrollTo(0, 0);
  }

  fetchProgrami() {
    this._rtsBackendService
      .fetchSettings(
        FormCode.MSPRO_PRO,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .subscribe(response => {
        this._spinner.hide();
        const programi = response.ServiceData.Data;
        const parsed = this.utilService.parseEnum(programi);
        this._listService.registerEnum('ProgramIdEnum', parsed);
      });
  }

  valueChanged(event: any) {
    if (event.newValue) {
      this.canGenerate = false;
      switch (event.fieldMap.fieldKey) {
        case 'Ugovor':
          this.fieldStructure.getFieldByName('Podugovor').editable = true;
          this.fieldStructure.getFieldByName('Podugovor').additable = true;

          this.report.Ugovor = event.newValue;
          this.report.Podugovor = {};
          this.fieldStructure.getFieldByName('Podugovor').lookupInitFilter = [
            {
              value: this.report.Ugovor.Id,
              name: 'ugovorId',
            },
          ];
          break;
        case 'Podugovor':
          this.report.Podugovor = event.newValue;
          break;
      }
    }
  }

  startValidation() {
    this.actionType = ActionType.Create;
    this.validateSubject.next();
  }

  settingsLoadSingle() {
    setTimeout(() => {
      const data = this.izvestajSettings.getGlinkHeader;
      this.settingsData = this.izvestajSettings.Glink16Table;
      this.settingsTable = new TableSettings(this.settingsData, 'table');
      this.settingsTableSource.next(this.settingsTable);
      this.fieldStructure = new FieldStructure(data, 'header');
      this.fieldStructure.getFieldByName('Podugovor').editable = false;
      this.fieldStructure.getFieldByName('Podugovor').additable = false;

      this.registerStatusEnum();
    }, 0);
  }

  registerStatusEnum() {
    this._listService.registerEnum(
      'StatusRezervacijeEnum',
      this.izvestajSettings.statusRezervacije
    );
  }

  getRequestObject() {
    return {
      Ugovor: this.report.Ugovor,
      Podugovor: this.report.Podugovor,
      DatumOd: this.report.DatumOd
        ? moment(this.report.DatumOd).format(DEFAULT_DATE_FORMAT)
        : null,
      DatumDo: this.report.DatumDo
        ? moment(this.report.DatumDo).format(DEFAULT_DATE_FORMAT)
        : null,
      ProgramId: this.report.ProgramIds,
      Status: this.report.Status,
    };
  }

  filter() {
    this._spinner.show();
    const entity = this.getRequestObject();
    const payload = this.reportService.getPayload(
      null,
      entity,
      FormCode.MSRR_GLINK,
      ReportNameEnum.Glink,
      EndpointTypeEnum.Form,
      RequestTypeEnum.Post
    );

    this.reportService.getFormData(payload).subscribe(data => {
      if (data.Errors && data.Errors.length) {
        this.canGenerate = false;
        this.notificationService.notyError(data.Errors[0].ErrorMessage);
        this.orderList = [];
        this._spinner.hide();

        return;
      } else {
        this.canGenerate = true;
        this.orderList = data.ServiceData.Tabela;
        this.totals = data.ServiceData.Totals;
      }

      this.documentListSource.next(this.orderList);

      this._spinner.hide();
      if (this.orderList.length < 1) {
        this.canGenerate = false;
        this.notificationService.notifyError(
          'Ne postoji ni jedna rezervacija za zadate filtere.'
        );

        return;
      }
    });
  }

  onToolbarActionExport() {
    this._spinner.show();
    if (!this.orderList.length || this.canGenerate === false) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      this._spinner.hide();

      return;
    }

    const report = {
      Header: this.getRequestObject(),
      Table: this.orderList,
    };

    const request = this.reportService.getPayload(
      null,
      report,
      FormCode.MSRR_GLINK,
      ReportNameEnum.Glink,
      EndpointTypeEnum.Xls
    );

    this.reportService.exportToDocument(request).subscribe(
      data => {
        const formattedDate: string = `${moment(new Date()).format(
          'YYYY-MM-DD_HH:mm'
        )}`.replace(
          `${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`.charAt(13),
          '-'
        );

        ReportService.downloadBlob(
          data,
          MimeFileType.Xlsx,
          `Pregled_rezervisanih_termina_${formattedDate}`
        );

        this._spinner.hide();
      },
      error => this._spinner.hide()
    );
  }

  onToolbarActionPrint() {
    this._spinner.show();
    if (!this.orderList.length || this.canGenerate === false) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      this._spinner.hide();

      return;
    }

    const report = {
      Header: this.getRequestObject(),
      Table: this.orderList,
    };

    const request = this.reportService.getPayload(
      null,
      report,
      FormCode.MSRR_GLINK,
      ReportNameEnum.Glink,
      EndpointTypeEnum.Pdf
    );

    this.reportService.exportToDocument(request).subscribe(
      data => {
        this._spinner.hide();
        ReportService.openBlob(data, MimeFileType.Pdf);
      },
      error => this._spinner.hide()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/glink-maska-16/glink-maska-16.component.ts